// @ts-nocheck
/* eslint-disable */

import React from 'react';
import ViewEntity from 'app/components/CRUD/ViewEntity';

import {
  CONFIG_PATHS,
  CONFIG_ROUTES,
  getCurrentLanguageCode,
} from 'app/configuration/configuration-api';

const ViewFareMediaType: React.FC = () => {
  const yesNo = (value, intl) =>
    value ? intl.formatMessage({ id: 'Yes' }) : intl.formatMessage({ id: 'No' });

  return (
    <ViewEntity
      pageTitle="FareMediaTypeInfo"
      fetchApiUrl={CONFIG_PATHS.fareMediaTypeById}
      fetchApiMethod="GET"
      dataPath="data.data"
      fields={[
        { name: 'en_name', labelKey: 'NameEnglish', type: 'text' },
        { name: 'ar_name', labelKey: 'NameArabic', type: 'text' },
        {
          name: 'is_test',
          labelKey: 'IsTest',
          type: 'custom',
          // ViewEntity calls render(entityData, additionalData, intl).
          render: (data, additionalData, intl) => yesNo(data.is_test, intl),
        },
        {
          name: 'is_old',
          labelKey: 'IsOld',
          type: 'custom',
          render: (data, additionalData, intl) => yesNo(data.is_old, intl),
        },
        {
          // Why a delete may be refused, visible before it is attempted.
          name: 'fare_media_count',
          labelKey: 'IssuedFareMedia',
          type: 'custom',
          render: data =>
            data.fare_media_count === undefined ? '-' : data.fare_media_count,
        },
        { name: 'created_by_username', labelKey: 'CreatedBy', type: 'text' },
        { name: 'created_at', labelKey: 'CreatedAt', type: 'date' },
        { name: 'updated_at', labelKey: 'UpdatedAt', type: 'date' },
      ]}
      editUrl={`${CONFIG_ROUTES.fareMediaTypes}/:id/edit`}
      deleteApiUrl={CONFIG_PATHS.fareMediaTypeById}
      deleteApiMethod="DELETE"
      backUrl={CONFIG_ROUTES.fareMediaTypes}
      backButtonLabel="Back"
      buildTitle={data =>
        getCurrentLanguageCode() === 'en-us' ? data.en_name : data.ar_name
      }
      buildDeleteConfirmMessage={(data, additionalData, currentLanguageCode, intl) => {
        const name = currentLanguageCode === 'en-us' ? data.en_name : data.ar_name;
        return `${intl.formatMessage({ id: 'AreYouSureDeleteFareMediaType' })} ${name}?`;
      }}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName="FareMediaTypes"
      permissionSystem="masterConfig"
    />
  );
};

export default ViewFareMediaType;
